/**
 * Pulls a camera from the state and applies it to the curernt camera.
 * @param {Object} state - The current state.
 * @param {Object} action - Details of the request. Holds the id of the camera being targeted.
 * @return {Object} The new state.
*/

export default function updateCurrentEntity(state, action) {

  return Object.assign({}, state, {
    currentEntity: action.entity,
    ui: {
      ...state.ui,
      sidebarView: 'cameraDetails'
    }
  })
}



// WEBPACK FOOTER //
// ./src/reducers/updateCurrentEntity.js